import React, { useState } from "react";
import ReactMarkdown from "react-markdown";

const ConversationFollowUp = ({ conversation, hideTitle = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleSummary = () => setIsExpanded(prev => !prev);

  if (typeof conversation?.summary !== "string") return "N/A";

  const [, rawFollowUp] = conversation.summary.split("\n\n");

  if (typeof rawFollowUp !== "string") return "N/A";

  const followUp = rawFollowUp?.replace("Follow-up action: ", "");
  const shortSummary = followUp.substring(0, 100);

  return (
    <div>
      {!hideTitle && (
        <span className="font-semibold max-w-full break-words">Summary:</span>
      )}
      {followUp.length <= 30 || isExpanded ? (
        <>
          <ReactMarkdown>{followUp}</ReactMarkdown>
          <button className="italic underline" onClick={toggleSummary}>
            (show less)
          </button>
        </>
      ) : (
        <div className="text-sm">
          {shortSummary}...
          <button className="italic underline" onClick={toggleSummary}>
            (show more)
          </button>
        </div>
      )}
    </div>
  );
};

export default ConversationFollowUp;
